module.exports = __webpack_public_path__ + "static/media/2.967343e7.jpg";